exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay--active:before{opacity:1!important}[dir] .overlay--active:before{background:rgba(0,0,0,.5)!important}.detail-table .section-title{opacity:.7}[dir] .detail-table .section-title{padding-top:0}[dir=ltr] .detail-table .section-title{padding-left:0}[dir=rtl] .detail-table .section-title{padding-right:0}.detail-table tr td{font-size:14px}[dir] .detail-table tr td{padding:3px 10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-00912000","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/exportOrder/viewExportOrderDetails.vue
// module id = 1385
// module chunks = 0